import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { BackLink } from '../BackLink/BackLink';
import { HaveAnAccountLink } from '../HaveAnAccountLink/HaveAnAccountLink';
import { HeaderLogo } from '../HeaderLogo/HeaderLogo';
import { ProgressIndicator } from '../ProgressIndicator/ProgressIndicator';
import { AccountSelector, HeaderContainer, Logo } from './Header.styles';
export const Header = ({
  totalSteps = 0,
  currentStepNumber = 0,
  showMobileView,
  accountLinkMessage,
  accountLinkHref = '',
  showProgressIndicator,
  showLogo,
  showHaveAnAccountLink,
  logoAltText = '',
  logoImageSrc,
  showBackLink,
  onAccountLinkClick,
  onLogoClick,
  onBackLinkClick,
  shouldLogoBeClickable,
  shouldHalveProgressBar,
  logoWidth,
  logoHeight
}) => {
  const displayBackLink = showMobileView && showBackLink;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showProgressIndicator && /*#__PURE__*/_jsx(ProgressIndicator, {
      totalSteps: totalSteps,
      currentStepNumber: currentStepNumber,
      shouldHalveProgressBar: shouldHalveProgressBar
    }), /*#__PURE__*/_jsxs(HeaderContainer, {
      children: [showLogo && /*#__PURE__*/_jsx(Logo, {
        children: /*#__PURE__*/_jsx(HeaderLogo, {
          altText: logoAltText,
          showMobileView: showMobileView,
          imageSrc: logoImageSrc,
          height: logoHeight,
          onClick: onLogoClick,
          shouldLogoBeClickable: shouldLogoBeClickable,
          width: logoWidth
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [showHaveAnAccountLink && /*#__PURE__*/_jsx(AccountSelector, {
          displayBackLink: displayBackLink,
          children: /*#__PURE__*/_jsx(HaveAnAccountLink, {
            href: accountLinkHref,
            accountLinkMessage: accountLinkMessage,
            onClick: onAccountLinkClick
          })
        }), displayBackLink && /*#__PURE__*/_jsx(BackLink, {
          onClick: onBackLinkClick
        })]
      })]
    })]
  });
};